import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { assignQRToUser, getLink } from "../api/qrcode";
import { checkLogin } from "../api/auth";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import isBetween from "dayjs/plugin/isBetween.js";
import CustomParseFormat from "dayjs/plugin/customParseFormat.js";
dayjs.extend(utc);
dayjs.extend(isBetween);
dayjs.extend(timezone);
dayjs.extend(CustomParseFormat);

const NotFound = () => {
  const params = useLocation();
  const navigate = useNavigate();
  const currentTimeIn = dayjs.tz.guess() || "";
  useEffect(() => {
    const fetchLink = async (link) => {
      try {
        const { data } = await getLink(link);
        if (data.barcode) {
          const { barcode } = data;
          if (barcode?.storedInfo) {
            if (
              barcode?.storedInfo.infoType === "phoneNumber" &&
              barcode?.storedInfo.phoneNumber
            ) {
              // window.open = `tel:${barcode?.storedInfo.link}`;
              var phoneNumber = `${barcode?.storedInfo.phoneNumber}`;
              var phoneLink = document.createElement("a");
              phoneLink.href = "tel:" + encodeURIComponent(phoneNumber);
              phoneLink.click();
            } else if (barcode?.storedInfo.infoType === "image") {
              navigate(`/image-videos/${data.barcode._id}`);
              return;
            } else if (
              barcode?.storedInfo.infoType === "link" &&
              barcode?.storedInfo.link
            ) {
              let url = barcode?.storedInfo.link;
              if (!(url.includes("http://") || url.includes("https://"))) {
                url = "https://" + url;
              }
              window.location.href = url;
            } else if (
              barcode?.storedInfo.infoType === "pdf" &&
              barcode?.storedInfo.pdf
            ) {
              let url = barcode?.storedInfo.pdf;
              if (!(url.includes("http://") || url.includes("https://"))) {
                url = "https://" + url;
              }
              window.location.href = url;
            } else if (barcode?.storedInfo.infoType === "memories") {
              navigate(`/info/${data.barcode._id}`);
            } else if (barcode?.storedInfo.infoType === "smartQR") {
              const timezone = currentTimeIn;
              const now = dayjs().tz(timezone);

              const today = now.format("YYYY-MM-DD");

              const barcodeSmartQR =
                barcode?.storedInfo?.smartQR?.conditions?.filter(
                  (item) => item?.timeZone === timezone
                ) || {};

              // Then process the items with proper null checks
              const matchedItem = barcodeSmartQR
                .map((item) => {
                  try {
                    const startTime = dayjs.tz(
                      `${today} ${item?.from || "00:00"}`,
                      "YYYY-MM-DD HH:mm",
                      timezone
                    );

                    const endTime = dayjs.tz(
                      `${today} ${item?.to || "23:59"}`,
                      "YYYY-MM-DD HH:mm",
                      timezone
                    );

                    return {
                      ...item,
                      startTime,
                      endTime,
                    };
                  } catch (error) {
                    console.error("Error processing time slot:", error, item);
                    return null;
                  }
                })
                .filter((item) => {
                  const isWithinTime =
                    now.isAfter(item.startTime) && now.isBefore(item.endTime);
                  return isWithinTime;
                })
                .sort((a, b) => a.startTime.diff(b.startTime))
                .pop();

                console.log("🚀 ~ fetchLink ~ matchedItem:", matchedItem);

              if (matchedItem) {
                let nextUrl = matchedItem.url;

                if (
                  !nextUrl.startsWith("http://") &&
                  !nextUrl.startsWith("https://")
                ) {
                  nextUrl = "https://" + nextUrl;
                }

                window.location.href = nextUrl;
              } else if (!matchedItem && barcode?.storedInfo?.smartQR?.defaultUrl) {
                let nextUrl = barcode?.storedInfo?.smartQR?.defaultUrl;

                if (
                  !nextUrl.startsWith("http://") &&
                  !nextUrl.startsWith("https://")
                ) {
                  nextUrl = "https://" + nextUrl;
                }

                window.location.href = nextUrl;
              } else {
                window.location.href = "https://rainbowrebels.store";
              }
            } else if (
              barcode?.approved &&
              barcode.isActive &&
              !barcode.user &&
              !barcode.restricted
            ) {
              assignUser(barcode);
            } else {
              window.location.href = "https://rainbowrebels.store";
            }
          } else if (
            barcode?.approved &&
            barcode.isActive &&
            !barcode.user &&
            !barcode.restricted
          ) {
            assignUser(barcode);
          } else {
            window.location.href = "https://rainbowrebels.store";
          }
        }
        return null;
      } catch (error) {
        console.log("Error while getting link");
      }
    };
    fetchLink(params.pathname.replace("/", ""));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const assignUser = async (barcode) => {
    try {
      const { data } = await checkLogin();
      if (data.user.role !== "admin" && data.user.emailVerified) {
        await assignQRToUser({
          link: barcode?._id,
          user: data.user._id,
        });
        navigate("/");
        return true;
      } else if (data.user.role !== "admin" && !data.user.emailVerified) {
        window.location.href = "https://rainbowrebels.store";
      }
    } catch (error) {
      navigate("/register", { state: { barcode } });
    }
  };

  return null;
};

export default NotFound;
